import { FilterSourcesModel } from "../../../filters/index.js";
function getCellProps(props, {
  cell,
  instance
}) {
  const attribute = cell?.column?.attribute;
  const filters = instance?.context?.clientProps?.filters || {};
  const delegate = instance?.context?.clientProps?.delegate;
  const metadatas = FilterSourcesModel.getMetadata(filters);
  const filterBarSortMetadata = metadatas?.filterBar?.sort;
  const filterBarFilterMetadata = metadatas?.filterBar?.filter;
  const isFiltered = delegate?.isAttributeFiltered?.(attribute, filterBarFilterMetadata);
  const isSorted = delegate?.isAttributeSorted?.(attribute, filterBarSortMetadata);
  if (!filterBarSortMetadata && !filterBarFilterMetadata) {
    return props;
  }
  return {
    ...props,
    style: {
      ...props.style,
      backgroundColor: isFiltered ? 'var(--color-tableFiltered, rgba(190, 208, 249, 0.2))' : isSorted ? 'var(--color-tableSorted, rgba(211, 231, 235, 0.32))' : props.style?.color
    }
  };
}
function getHeaderProps(props, {
  instance,
  column
}) {
  const attribute = column?.attribute;
  const filters = instance?.context?.clientProps?.filters || {};
  const delegate = instance?.context?.clientProps?.delegate;
  const metadatas = FilterSourcesModel.getMetadata(filters);
  const filterBarSortMetadata = metadatas?.filterBar?.sort;
  const filterBarFilterMetadata = metadatas?.filterBar?.filter;
  if (!filterBarSortMetadata && !filterBarFilterMetadata) {
    return props;
  }
  const isFiltered = delegate?.isAttributeFiltered?.(attribute, filterBarFilterMetadata);
  const isSorted = delegate?.isAttributeSorted?.(attribute, filterBarSortMetadata);
  return {
    ...props,
    style: {
      ...props.style,
      backgroundColor: isFiltered ? 'var(--color-tableFiltered, rgba(190, 208, 249, 0.2))' : isSorted ? 'var(--color-tableSorted, rgba(211, 231, 235, 0.32))' : props.style?.color
    }
  };
}
function adjustSelectionCellWidth(userProps, {
  column
}) {
  if (column.id === 'targeted') {
    return {
      ...userProps,
      style: {
        width: '100%',
        ...userProps?.style
      }
    };
  }
  return userProps;
}
export default function useCellProps(hooks) {
  hooks.getCellProps.push(getCellProps);
  hooks.getHeaderProps.push(getHeaderProps);
  hooks.getSortByToggleProps.push(adjustSelectionCellWidth);
}